import { CircularProgress } from "@suraasa/placebo-ui"
import React, { useEffect, useState } from "react"

type Props = {
  src: string
  alt?: string
}

const ImageComponent = ({ src, alt = "Image" }: Props) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const img = new Image()
    img.src = src
    img.onload = () => setLoading(false)
  }, [src])

  return (
    <div>
      {loading ? (
        <div className="my-8 flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <img src={src} alt={alt} />
      )}
    </div>
  )
}

export default ImageComponent
